import { getFunctions, httpsCallable } from 'firebase/functions'

export type LearnAlertEvent =
  | 'lock_created'
  | 'ladder_lock_created'
  | 'ladder_complete'
  | 'claim_inflation'
  | 'early_exit'
  | 'withdraw_maturity'
  | 'admin_fund_inflation'
  | 'admin_distribute'
  | 'admin_withdraw_stable'
  | 'admin_withdraw_conversion'
  | 'admin_withdraw_excess'

export type LearnAlertPayload = {
  event: LearnAlertEvent
  email?: string | null
  wallet?: string | null
  amountLabel?: string | null
  lockDays?: number | null
  unlockLabel?: string | null
  positionId?: number | null
  txHash?: string | null
  detail?: string | null
  ladderIndex?: number | null
  ladderTotal?: number | null
}

/**
 * Fire-and-forget L-Earn SendGrid alert via Firebase callable `default-sendLearnAlert`.
 * Never throws — UI flows must not fail because email delivery failed.
 */
export async function notifyLearnAlert(payload: LearnAlertPayload): Promise<void> {
  try {
    const fn = httpsCallable(getFunctions(), 'default-sendLearnAlert')
    await fn(payload)
  } catch (err: unknown) {
    const msg = err instanceof Error ? err.message : String(err)
    // eslint-disable-next-line no-console
    console.warn('[learn-alert] send skipped/failed:', msg)
  }
}
